






import { Component, Vue } from 'vue-property-decorator'
import { getPlayAuth } from "@/api/course"
import UsageSender, { getSystem } from "@/utils/usage"
import audioBackground from '@/assets/images/background_audio.png'

declare const window: Window & {
  Aliplayer: any;
};
@Component({})
export default class extends Vue {
  public playerInstance: any = null
  public mediaId: string = ''

  private usageStopTimer: number | null = null
  private usageSender: { instance: any, params: any } = {
    instance: null,
    params: null,
  }

  private clearUsageStopTimer() {
    if (this.usageStopTimer) {
      window.clearTimeout(this.usageStopTimer)
      this.usageStopTimer = null
    }
  }

  private async setUsageStopTimer(cb: () => void, time: number) {
    this.usageStopTimer = window.setTimeout(cb, time)
  }

  private getUserInfo() {
    const userInfo = this.$store.state.UserModule.userInfo;
    return userInfo || {};
  }

  private getStoreToken() {
    const token = this.$store.state.AuthModule.token || window.localStorage.getItem('userToken');
    return token || "";
  }

  private getGradeValue() {
    const {grade} = this.$route.query;
    return grade || 0;
  }

  private getUsageParams() {
    const {id: userId = ''} = this.getUserInfo();
    const userType = 'teacher';
    const sessionId = this.getStoreToken();
    const coursewareGrade = this.getGradeValue();
    const coursewareType = this.$route.query.type || 'video';
    const isFromTeachingAux = !!this.$route.query.teachingAuxiliaryId
    const coursewareFrom: string = isFromTeachingAux ? 'zhzy' : 'zqkh';
    const coursewareId = (isFromTeachingAux ? String(this.$route.query.mediaId) : this.$route.params.uid) || '';
    const schoolId = this.$route.query.schoolId || ''
    const classId = this.$route.query.classId || ''
		const customer = 'pc'
    const version = getSystem()
    if (userId && sessionId) {
      const params:any = {
        a: userId,
        b: userType,
        c: sessionId,
        d: coursewareId,
        e: coursewareGrade,
        f: coursewareType,
        j: coursewareFrom,
        l: customer
      }
      if(schoolId)
        params['k'] = schoolId
      if(classId)
        params['h'] = classId
      if(version)
        params['v'] = version
      return params;
    } else {
      return null;
    }
  }

  public initUsageSender() {
    if (this.usageSender.instance) {
      return
    }
    const params: any = this.getUsageParams()
    if (params) {
      this.usageSender.params = params
      this.usageSender.instance = new UsageSender(params);
    } else {
      console.warn('授课统计参数错误')
    }
  }

  public stopUsageSender() {
    if (this.usageSender.instance instanceof UsageSender) {
      this.usageSender.instance.stop()
      this.usageSender.instance = null
    }
  }

  mounted() {
    this.mediaId = this.$route.params.mediaId
    this.mediaResourceInit()
  }

  // @Watch('$route.query', { deep: true, immediate: true })
  // private usageSenderWatch(){
  //   this.initUsageSender()
  // }

  unMounted() {
    this.stopUsageSender()
  }

  public async stopMediaPlaying() {
    if (!this.playerInstance) {
      return false
    }
    const status = this.playerInstance.getStatus();
    if (status === "playing") {
      await this.playerInstance.pause();
    }
    return true
  }

  public async mediaResourceInit() {
    const vid = this.mediaId;
    const mediaType = this.$route.query.type
    const playauth = await getPlayAuth(vid);
    const hasPlayer = await this.stopMediaPlaying();
    if (hasPlayer) {
      this.playerInstance.replayByVidAndPlayAuth(vid, playauth);
    } else {
      const config: any = {
        id: 'J_prismPlayer',
        width: '100%',
        playsinline: true,
        autoplay: true,
        vid, //必选参数。音视频ID。示例：1e067a2831b641db90d570b6480f****。
        playauth, //必选参数。音视频播放凭证。
        isVBR: true
      }
      if (mediaType == 'audio') {
        config.mediaType = 'audio'
      }
      //@ts-ignore
      const player = new window.Aliplayer(config, function (player: any) {
        if (mediaType == 'audio') {
          const playerBack: any = document.querySelectorAll('.prism-text-overlay')[0]
          const toolBarBack: any = document.querySelectorAll('.prism-controlbar-bg')[0]
          playerBack.style.background = `url('${audioBackground}') no-repeat`
          playerBack.style.backgroundSize = 'cover'
          toolBarBack.style.background = 'rgba(75,75,75,.85)'     //  因为背景改成了亮色所以修改透明度保证显示效果
        }
      });
      player.on('play', () => {
        this.clearUsageStopTimer()
        this.initUsageSender()
      })
      player.on('pause',  () => {
        const timeout = 3e+5
        this.setUsageStopTimer(() => {
          this.stopUsageSender()
        }, timeout)
      })
      this.playerInstance = player;
    }
  }
}
